exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:flex;padding:7px 4px;background:none;border:1px solid #e4e6fc;border-radius:4px;white-space:normal;min-width:360px}.vs__actions{padding:0 6px 0 3px}.vs__clear{display:none}.vs__dropdown-menu{background-color:#fff;border:1px solid #aaa;border-radius:4px;box-sizing:border-box;display:block;position:absolute;z-index:3000;max-height:120px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21a25378","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/produk/BuatProduk.vue
// module id = 239
// module chunks = 0